import { Component, Fragment } from 'react';
import moment from 'moment';
import ListItemIcon from '@mui/material/ListItemIcon';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import WorkIcon from '@mui/icons-material/Work';
import CarIcon from '@mui/icons-material/LocalTaxi';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IntlMessages from '../../util/IntlMessages';
import { Loading } from '../index';
import Status from '../Status';
import Toggle from './Toggle';

import { NavLink } from 'react-router-dom';

class DataTable extends Component {
  render() {
    return <Table>{this.props.children}</Table>;
  }
}

const DataTableHead = (props) => {
  const { columns, orderBy } = props;
  const updateProps = (data) => {
    if (props.sort) props.sort(data);
  };
  const rightColums = ['action'];
  return (
    <TableHead>
      <TableRow>
        {columns.length > 0 &&
          columns.map((column, colIdx) => {
            return (
              <TableCell
                colSpan={column.colspan ? column.colspan : 1}
                key={`${column.id}-${colIdx}`}
                style={column.style}
                align={!rightColums.includes(column.id) ? 'left' : 'right'}
                padding={column.disablePadding ? 'none' : 'default'}
                onClick={() =>
                  updateProps({
                    key: column.id,
                    order: parseInt(column.order) === 1 ? -1 : 1,
                  })
                }
              >
                {column.label}
                {orderBy === column.id && orderBy.toLowerCase() !== 'action' && (
                  <TableSortLabel active={true} direction={column.order === 1 ? 'asc' : 'desc'} />
                )}
              </TableCell>
            );
          })}
      </TableRow>
    </TableHead>
  );
};
DataTableHead.defaultProps = {
  style: {},
};

const TableCellPrint = (Dkey, key, index) => {
  const noImage = ['', null, undefined, 'none'];
  switch (key.type) {
    case 'paymentTag': {
      return (
        <TableCell padding="none" align="left" key={index}>
          {Dkey.paymentMethod === 'stripe'
            ? 'Card'
            : Dkey.paymentMethod === 'gPay' || Dkey.paymentMethod === 'applePay'
              ? Dkey.paymentMethod
              : 'Cash'}
        </TableCell>
      );
    }
    case 'Title': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          <span className={`label ${Dkey[key.id]}`}>
            {Status[Dkey[key.id]] ? (
              <IntlMessages id={`status.${Dkey[key.id]}`} />
            ) : (
              Dkey[key.id] && Dkey[key.id].charAt(0).toUpperCase() + Dkey[key.id].slice(1)
            )}
          </span>
        </TableCell>
      );
    }
    case 'action': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {key.action(Dkey)}
        </TableCell>
      );
    }
    case 'image': {
      return (
        <TableCell padding="none" key={index} align="left" style={key.style ? key.style : {}}>
          <div className="user-profile d-flex flex-row">
            <Avatar
              alt={Dkey['name']}
              src={
                !noImage.includes(Dkey[key.image])
                  ? Dkey[key.image]
                  : 'assets/images/placeholder.jpg'
              }
              className="ml-3 user-avatar"
            />
            {/* <div className="user-detail">
              <h5 className="user-name">{Dkey[key.id]} </h5>
            </div> */}
          </div>
        </TableCell>
      );
    }

    case 'onlineStatus': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {Dkey.token !== '' ? (
            <span className="ml-2">
              <i className="zmdi zmdi-circle zmdi-hc-lg" style={{ color: '#4CAF50' }}></i>{' '}
            </span>
          ) : (
            <span className="ml-2">
              <i className="zmdi zmdi-circle zmdi-hc-lg" style={{ color: '#FFC107' }}></i>
            </span>
          )}
        </TableCell>
      );
    }

    case 'date': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {moment(Dkey[key.id]).format('YYYY-MM-DD')}
        </TableCell>
      );
    }

    case 'currency': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {Number(Dkey[key.id] ?? Dkey['estimatedCost'] ?? 0).toFixed(2)} Kč
        </TableCell>
      );
    }

    case 'fleetName': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {Dkey.fleetName[0] || '---'}
        </TableCell>
      );
    }

    case 'driverDetail': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {Dkey.driverDetail[0] ? Dkey.driverDetail[0].name : '--'}
        </TableCell>
      );
    }

    case 'carTypeRequiredCarType': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {Dkey.carTypeRequired.carType ? Dkey.carTypeRequired.carType : '--'}
        </TableCell>
      );
    }
    case 'carStatus': {
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          {Dkey.status === 2 ? (
            <span className="badge badge-warning">Pending</span>
          ) : Dkey.status === 0 || Dkey.status === '0' ? (
            <span className="badge badge-danger">Disapproved</span>
          ) : (
            <span className="badge badge-success">Approved</span> || (
              <span className="badge badge-info">Pending</span>
            )
          )}
          {Dkey.isSelected ? <span className="badge bg-dark text-white">&#10003;</span> : <></>}
        </TableCell>
      );
    }
    case 'tripStatus': {
      let statusClass = 'badge badge-secondary';
      switch (Dkey[key.id]) {
        case 'Completed':
          statusClass = 'badge badge-success';
          break;
        case 'Cancelled':
          statusClass = 'badge badge-danger';
          break;
        case 'DestinationInroute':
          statusClass = 'badge badge-primary';
          break;
        case 'FindingTrips':
          statusClass = 'badge badge-info';
          break;
        case 'PickupInroute':
          statusClass = 'badge badge-warning';
          break;
        default:
          statusClass = 'badge badge-secondary';
          break;
      }
      return (
        <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
          <span className={statusClass}>
            {Status[Dkey[key.id]] ? (
              <IntlMessages id={`${Dkey[key.id]}`} />
            ) : Dkey[key.id] ? (
              Dkey[key.id].charAt(0).toUpperCase() + Dkey[key.id].slice(1)
            ) : (
              '--'
            )}
          </span>
        </TableCell>
      );
    }
    default: {
      if (Array.isArray(Dkey[key.id]) || key.numeric) {
        return (
          <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
            {Dkey[key.id] && Dkey[key.id].length > 0 ? Dkey[key.id].length : 0}
          </TableCell>
        );
      } else {
        return (
          <TableCell padding="none" align="left" key={index} style={key.style ? key.style : {}}>
            {Dkey[key.id] === 0 || Dkey[key.id] === '0' ? '0' : Dkey[key.id] || '--'}
          </TableCell>
        );
      }
    }
  }
};
class DataTableBody extends Component {
  render() {
    const {
      loading,
      page,
      rowsPerPage,
      data,
      column,
      actions,
      actionBtn,
      invoiceBtn,
      driverBtn,
      popupBtn,
      deletePopupBtn,
      openPdf,
      regenBtn,
      enableToggleSelect,
      api_url,
      selectedCars,
      supportChatToggle,
    } = this.props;
    const notDisplay = ['_id', 'action', 'regen'];
    return (
      <TableBody>
        {loading === false &&
          data.length > 0 &&
          data.map((Dkey, index) => {
            const rowNumber = index + 1 + page * rowsPerPage;
            return (
              <TableRow hover tabIndex={-1} key={Dkey._id}>
                <TableCell padding="none" align="left">
                  {rowNumber}
                </TableCell>
                {column
                  .filter((key) => !notDisplay.includes(key.id))
                  .map((colKey, colIdx) => TableCellPrint(Dkey, colKey, colIdx))}
                {actions && (
                  <TableCell padding="none" align="right" key={`${Dkey._id}-actions`}>
                    <Action actions={actions} id={Dkey._id} driverId={Dkey.driverId || ''} />
                  </TableCell>
                )}
                {invoiceBtn && (
                  <TableCell
                    padding="none"
                    align="right"
                    key={`${Dkey._id}-invoice`}
                    style={{ width: '45px', padding: '0 4px' }}
                  >
                    <NavLink to={`/app/invoice/list/${Dkey._id}`}>
                      <Button
                        className="bg-amber text-white CBmargin"
                        style={{
                          margin: 0,
                          minWidth: '28px',
                          width: '28px',
                          height: '28px',
                          padding: 0,
                          borderRadius: '4px',
                        }}
                        title={invoiceBtn.title || 'Invoices'}
                      >
                        <i className={`zmdi ${invoiceBtn.icon}`} style={{ fontSize: '13px' }} />{' '}
                        {invoiceBtn.title}
                      </Button>
                    </NavLink>
                  </TableCell>
                )}
                {supportChatToggle && (
                  <TableCell padding="none" align="center" key={`${Dkey._id}-supportChat`}>
                    {typeof supportChatToggle.render === 'function'
                      ? supportChatToggle.render(Dkey)
                      : null}
                  </TableCell>
                )}
                {actionBtn && (
                  <TableCell
                    padding="none"
                    align="right"
                    key={`${Dkey._id}-action`}
                    style={{ width: '45px', padding: '0 4px' }}
                  >
                    <NavLink to={`${actionBtn.link}${Dkey._id}`}>
                      <Button
                        className="bg-amber text-white CBmargin"
                        style={{
                          margin: 0,
                          minWidth: '28px',
                          width: '28px',
                          height: '28px',
                          padding: 0,
                          borderRadius: '4px',
                        }}
                        title={actionBtn.title || 'Edit'}
                      >
                        <i className={`zmdi ${actionBtn.icon}`} style={{ fontSize: '13px' }} />{' '}
                        {actionBtn.title}
                      </Button>
                    </NavLink>
                  </TableCell>
                )}
                {driverBtn && (
                  <TableCell
                    padding="none"
                    align="right"
                    key={`${Dkey._id}-driver`}
                    style={{ width: '45px', padding: '0 4px' }}
                  >
                    <NavLink to={`${driverBtn.link}${Dkey._id}`}>
                      <Button
                        className="bg-primary text-white CBmargin"
                        style={{
                          margin: 0,
                          minWidth: '28px',
                          width: '28px',
                          height: '28px',
                          padding: 0,
                          borderRadius: '4px',
                        }}
                        title={driverBtn.title || 'Drivers'}
                      >
                        <i className={`zmdi ${driverBtn.icon}`} style={{ fontSize: '13px' }} />{' '}
                        {driverBtn.title}
                      </Button>
                    </NavLink>
                  </TableCell>
                )}
                {popupBtn && (
                  <Fragment key={`${Dkey._id}-popup-group`}>
                    <TableCell
                      padding="none"
                      align="right"
                      key={`${Dkey._id}-popup`}
                      style={{ width: '45px', padding: '0 4px' }}
                    >
                      <Button
                        style={{
                          margin: 0,
                          minWidth: '28px',
                          width: '28px',
                          height: '28px',
                          padding: 0,
                          borderRadius: '4px',
                        }}
                        className="bg-amber text-white CBmargin"
                        onClick={() => popupBtn.action(true, Dkey._id)}
                      >
                        <i
                          className={`${popupBtn.icon ? popupBtn.icon : 'zmdi zmdi-eye'}`}
                          style={{ fontSize: '13px' }}
                        />
                      </Button>
                    </TableCell>
                    {deletePopupBtn && deletePopupBtn.isTrue && (
                      <TableCell
                        padding="none"
                        align="right"
                        key={`${Dkey._id}-delete-popup`}
                        style={{ width: '45px', padding: '0 4px' }}
                      >
                        <Button
                          style={{
                            margin: 0,
                            minWidth: '28px',
                            width: '28px',
                            height: '28px',
                            padding: 0,
                            borderRadius: '4px',
                            backgroundColor: '#f44336',
                          }}
                          className="bg-red-600 text-white"
                          title={deletePopupBtn.title || 'Delete'}
                          onClick={() => deletePopupBtn.action(Dkey._id)}
                        >
                          <i className="zmdi zmdi-delete" style={{ fontSize: '13px' }} />
                        </Button>
                      </TableCell>
                    )}
                  </Fragment>
                )}

                {!popupBtn && deletePopupBtn && deletePopupBtn.isTrue && (
                  <TableCell
                    padding="none"
                    align="right"
                    key={`${Dkey._id}-delete`}
                    style={{ width: '45px', padding: '0 4px' }}
                  >
                    <Button
                      style={{
                        margin: 0,
                        minWidth: '28px',
                        width: '28px',
                        height: '28px',
                        padding: 0,
                        borderRadius: '4px',
                        backgroundColor: '#f44336',
                      }}
                      className="bg-red-600 text-white"
                      title={deletePopupBtn.title || 'Delete'}
                      onClick={() => deletePopupBtn.action(Dkey._id)}
                    >
                      <i className="zmdi zmdi-delete" style={{ fontSize: '13px' }} />
                    </Button>
                  </TableCell>
                )}

                {openPdf && (
                  <TableCell
                    padding="none"
                    align="right"
                    key={`${Dkey._id}-pdf`}
                    style={{ width: '45px', padding: '0 4px' }}
                  >
                    <Button
                      style={{
                        margin: 0,
                        minWidth: '28px',
                        width: '28px',
                        height: '28px',
                        padding: 0,
                        borderRadius: '4px',
                      }}
                      className="bg-amber text-white CBmargin"
                      onClick={() => openPdf.action(Dkey.s3Path)}
                    >
                      <i
                        className={`${openPdf.icon ? openPdf.icon : 'zmdi zmdi-eye'}`}
                        style={{ fontSize: '13px' }}
                      />
                    </Button>
                  </TableCell>
                )}
                {regenBtn && (
                  <TableCell
                    padding="none"
                    align="right"
                    key={`${Dkey._id}-regen`}
                    style={{ width: '45px', padding: '0 4px' }}
                  >
                    <Button
                      style={{
                        margin: 0,
                        minWidth: '28px',
                        width: '28px',
                        height: '28px',
                        padding: 0,
                        borderRadius: '4px',
                      }}
                      className="bg-amber text-white CBmargin"
                      onClick={() => regenBtn.action(Dkey._id, Dkey)}
                    >
                      <i
                        className={`zmdi ${regenBtn.icon ? regenBtn.icon : 'zmdi-refresh'}`}
                        style={{ fontSize: '13px' }}
                      />
                    </Button>
                  </TableCell>
                )}
                {enableToggleSelect === true && (
                  <TableCell padding="none" align="right" key={`${Dkey._id}-toggle`}>
                    <Toggle data={Dkey} api_url={api_url} selectedCars={selectedCars} />
                  </TableCell>
                )}
              </TableRow>
            );
          })}

        {loading === false && data.length === 0 && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              <IntlMessages id="common.nodata" />
            </TableCell>
          </TableRow>
        )}
        {loading === true && (
          <TableRow>
            <TableCell align="center" colSpan={column.length}>
              <Loading />
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    );
  }
}

class DataTablePagination extends Component {
  render() {
    const { count, page, rowsPerPage, rowsPerPageOptions, onChangePage } = this.props;
    return (
      <TableFooter>
        <TableRow>
          <TablePagination
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={onChangePage}
            rowsPerPageOptions={rowsPerPageOptions}
          />
        </TableRow>
      </TableFooter>
    );
  }
}

class Action extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      anchorEl: undefined,
      menuState: false,
    };

    this.onOptionMenuSelect = this.onOptionMenuSelect.bind(this);
    this.handleRequestClose = this.handleRequestClose.bind(this);
  }

  onOptionMenuSelect = (event) => {
    this.setState({ menuState: true, anchorEl: event.currentTarget });
  };

  handleRequestClose = () => {
    this.setState({ menuState: false });
  };

  render() {
    const { id, actions, driverId } = this.props;
    const { menuState, anchorEl } = this.state;

    return (
      <Fragment>
        <IconButton key={id} onClick={(e) => this.onOptionMenuSelect(e)}>
          <i className="zmdi zmdi-more-vert" />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={menuState}
          onClose={() => this.handleRequestClose()}
          MenuListProps={{
            style: {
              width: 93,
              paddingTop: 0,
              paddingBottom: 0,
            },
          }}
        >
          {actions &&
            actions.map((key) => {
              if (key.action) {
                return (
                  <MenuItem
                    key={key['label']}
                    onClick={() => key.action(true, id)}
                    className="customIcon"
                  >
                    <ListItemIcon>
                      <VisibilityIcon fontSize="small" />
                      <IntlMessages id="common.view" />
                    </ListItemIcon>
                  </MenuItem>
                );
              } else if (key['label'] === 'Delete') {
                return (
                  <MenuItem
                    key={key['label']}
                    onClick={() => this.handleRequestClose()}
                    className="customIcon"
                  >
                    {/* <a href="javascript:void(0)" onClick={() => key.link(id)}> */}
                    <button
                      type="button"
                      onClick={() => key.link(id)}
                      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}
                    >
                      <ListItemIcon>
                        <DeleteForeverIcon fontSize="small" />
                        <IntlMessages id="common.delete" />
                      </ListItemIcon>
                    </button>
                    {/* </a> */}
                  </MenuItem>
                );
              } else if (key['label'] === 'View Vehicles') {
                return (
                  <MenuItem key={key['label']} className="customIcon">
                    <a href={`#${key.link}${driverId}`} target="_blank" rel="noreferrer">
                      <ListItemIcon>
                        <VisibilityIcon fontSize="small" />
                        <IntlMessages id="Manage" />
                      </ListItemIcon>
                    </a>
                  </MenuItem>
                );
              } else if (key['label'] === 'Detail Vehicles') {
                return (
                  <MenuItem key={key['label']} className="customIcon">
                    <a href={`#${key.link}${driverId}/${id}`} target="_blank" rel="noreferrer">
                      <ListItemIcon>
                        <EditIcon fontSize="small" />
                        <IntlMessages id="Detail" />
                      </ListItemIcon>
                    </a>
                  </MenuItem>
                );
              } else {
                return (
                  <MenuItem
                    key={key['label']}
                    onClick={() => this.handleRequestClose()}
                    className="customIcon"
                  >
                    <NavLink to={`${key.link}/${id}`}>
                      <ListItemIcon>
                        {key['icon'] !== '' && key['icon']}
                        {key['label'] === 'View' && (
                          <Fragment>
                            <VisibilityIcon fontSize="small" />
                            <IntlMessages id="common.view" />
                          </Fragment>
                        )}
                        {key['label'] === 'Edit' && (
                          <Fragment>
                            <EditIcon fontSize="small" />
                            <IntlMessages id="common.edit" />
                          </Fragment>
                        )}
                        {key['label'] === 'Pay' && (
                          <Fragment>
                            <AccountBalanceIcon fontSize="small" />
                            <IntlMessages id="common.pay" />
                          </Fragment>
                        )}
                        {key['label'] === 'Earning' && (
                          <Fragment>
                            <WorkIcon fontSize="small" />
                            Earning
                          </Fragment>
                        )}
                        {key['label'] === 'Manage Cars' && (
                          <Fragment>
                            <CarIcon fontSize="small" />
                            Cars
                          </Fragment>
                        )}
                      </ListItemIcon>
                    </NavLink>
                  </MenuItem>
                );
              }
            })}
        </Menu>
      </Fragment>
    );
  }
}

const ActionLink = (props) => {
  const { index, actionBtn, id } = props;
  return (
    <TableCell padding="none" align="right" key={index}>
      <NavLink to={`${actionBtn.link}${id}`}>
        <Button className="bg-amber text-white CBmargin">
          <i className={`zmdi ${actionBtn.icon}`} /> {actionBtn.title}
        </Button>
      </NavLink>
    </TableCell>
  );
};
const ActionPopup = (props) => {
  const { key, action, id, title, icon } = props;
  return (
    <TableCell padding="none" align="right" key={key}>
      <Button className="bg-amber text-white CBmargin" onClick={() => action(id)}>
        <i className={`zmdi ${icon}`} /> {title}
      </Button>
    </TableCell>
  );
};
ActionPopup.defaultProps = {
  key: Math.random(),
  title: '',
  icon: 'Zmdi-delete',
};

// DataTable= withRouter(DataTable)
// DataTableHead= withRouter(DataTableHead)
// DataTableBody= withRouter(DataTableBody)
// DataTablePagination= withRouter(DataTablePagination)
export {
  DataTable,
  DataTableHead,
  DataTableBody,
  DataTablePagination,
  Action,
  ActionPopup,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  ActionLink,
  moment,
};
